import cashbackApi from '../../api/pvCashback.api';

// initial state
const state = {
  cashback: {},
  cashbacks: [],

  cashbacksTotal: 0,
};

// getters
const getters = {
  cashback: state => state.cashback,
  cashbacks: state => state.cashbacks,

  cashbacksTotal: state => state.cashbacksTotal,
};

// actions
const actions = {
  // ADMIN
  findAdminPVCashbacks({ commit }, payload) {
    return cashbackApi.findAdminPVCashbacks(payload)
      .then((response) => {
        const { cashbacks, cashbacksTotal } = response;
        commit('CASHBACKS', cashbacks);
        commit('CASHBACKS_TOTAL', cashbacksTotal);
      });
  },

  updateAdminCashbackByKey({ commit }, payload) {
    commit('ACTIVATION_STATUS', 'LOADING');
    return cashbackApi.updateAdminCashbackByKey(payload)
      .then((response) => {
        commit('UPDATE_CASHBACK', response.cashback);
        commit('ACTIVATION_STATUS', 'FINISHED');
        return;
      });
  },
};

// mutations
const mutations = {
  CASHBACK(state, cashback) {
    state.cashback = cashback;
  },
  CASHBACKS(state, cashbacks) {
    state.cashbacks = cashbacks;
  },
  UPDATE_CASHBACK(state, cashback) {
    for (let i = 0; i < state.cashbacks.length; i++) {
      const cb = state.cashbacks[i];
      if (cb._id == cashback._id) {
        state.cashbacks[i] = cashback;
      }
    }
  },
  CASHBACKS_TOTAL(state, cashbacksTotal) {
    state.cashbacksTotal = cashbacksTotal;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
